import Breadcrumbs from '@lotlinx-aws/sparky-component-library/Sparky/Breadcrumbs';

import styles from './GeoConfigHeader.module.scss';

/**
 * GeoConfigHeader
 */
export default function GeoConfigHeader() {
  return (
    <Breadcrumbs
      pageTitles={[{ title: 'Dealer settings' }, { title: 'Geo Configuration' }]}
      className={styles.geoConfigHeader}
    />
  );
}
